import {
  ActionType,
  IDepartmentListResponse,
} from "models/stressCheck/departmentList";

export const getDepartmentListAction = () => {
  return {
    type: ActionType.STRESS_DEPARTMENT_LIST,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.STRESS_DEPARTMENT_LIST_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IDepartmentListResponse) => {
  return {
    type: ActionType.STRESS_DEPARTMENT_LIST_SUCCESS,
    payload,
  };
};
